module.exports = __webpack_public_path__ + "img/accessory_hat_12.6d8f4154.svg";